<template>
  <div class="is-marginless is-paddingless section section-details" v-if="contact">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailContact.title', { nomPrenom: getNomPrenom })}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
          <dropdownButton
            type="is-addOrEdit"
            class="mgr-2"
            :permission="permClientsContacts.maj"
            :actions="actionSecondary"
            @click="() => {
              $router.push({ name: 'm.bodac.clients/contacts-editContact',
          params: {id: contact.id,
            isFromBailleur: $route.params.isFromBailleur
              || ( contact.accesPortail && modulePortailBailleurActive) }});
            }">
              {{ $t('detailContact.actions.edit')}}
          </dropdownButton>
          </div>
        </div>
      </div>
      <div class="tab mgr-0 mgl-0">
        <ul>
          <li
            v-for="(tab, index) in tabs" :key="index"
            :class="{'is-active': activeTab === tab}"
            @click="activeTab = tab">
            {{ $t(`editionContact.tabs.${tab}`) }}
          </li>
        </ul>
      </div>
    </div>
    <div class="pdt-20px" v-if="activeTab === constantes.TAB_INFORMATIONS">
      <div class="columns">
        <div class=" column is-6">
          <div class="card">
            <header class="header-card">
              <p>
                {{ $t('editionClient.generalTitle.generalInformations')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns">
                <div class="column is-3">
                  <avatar :username="contact.prenom + ' ' + contact.nom + contact.fonction"
                          :size="90"></avatar>
                </div>
                <div class="column is-7">
                  <div class="columns is-multiline">
                    <p class="column is-10">
                      <span class="has-text-default">{{civilite}}&nbsp;</span>
                      <span class="title is-4">{{contact.prenom}}&nbsp;</span>
                      <span class="title is-4">{{contact.nom}}</span>
                      <br>
                      <span class="has-text-secondary-icon">{{contact.fonction}}</span>
                      -
                      <router-link
                        :class="{
                        'text-access-no-permission' : !checkPermissions(permClientsContacts.lecture)
                          }"
                        :to="{
                          name: 'c.bodac.clients/contacts-client',
                          params: {id: contact.tiersId}
                          }">
                        <span class="lien">{{nomClient}}</span>
                      </router-link>
                      <br>
                      <span class="has-text-secondary-icon">{{typesContact}}</span>
                      <span v-if="contact.newsletter"
                        class="has-text-default has-text-weight-semibold">
                        {{ $t('detailContact.newsLetter') }}
                      </span>
                    </p>
                  <div class="column is-2">
                    <a>
                      <b-icon icon="email"></b-icon>
                    </a>
                  </div>
                  <div class="column">
                    <p>
                      <span class="has-text-default has-text-weight-semibold">
                        {{contact.telephone}}
                      </span><br>
                      <span class="has-text-default has-text-weight-semibold">
                       {{contact.portable}}
                      </span><br>
                      <a>
                        <span class="lien">
                          {{contact.email}}
                        </span>
                      </a>
                    </p>
                  </div>
                  <div class="column">
                    <p>
                      <span class="has-text-default is-italic">
                        {{$t('editionContact.postalAddress')}} :
                      </span><br>
                    </p>
                    <p class="has-text-default has-text-weight-semibold"
                       v-if="!contact.adresseContactDifferente && client.adressePostale">
                      {{client.adressePostale.intitule1}}
                      {{client.adressePostale.intitule2}}
                      {{client.adressePostale.intitule3}}
                      <br v-if="client.adressePostale.intitule1">
                      {{client.adressePostale.adresse1}}
                      {{client.adressePostale.adresse2}}
                      {{client.adressePostale.adresse3}}
                      <br v-if="client.adressePostale.adresse1">
                      {{client.adressePostale.codePostal}}
                      {{client.adressePostale.ville}}
                      {{client.adressePostale.pays}}
                    </p>
                    <p class="has-text-default has-text-weight-semibold" v-else>
                      {{contact.adresse.intitule1}}
                      {{contact.adresse.intitule2}}
                      {{contact.adresse.intitule3}}
                      <br v-if="contact.adresse.intitule1">
                      {{contact.adresse.adresse1}}
                      {{contact.adresse.adresse2}}
                      {{contact.adresse.adresse3}}
                      <br v-if="contact.adresse.adresse1">
                      {{contact.adresse.codePostal}}
                      {{contact.adresse.ville}}
                      {{contact.adresse.pays}}
                    </p>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class=" column is-6" v-if="afficherInfoPortail">
          <div class="card">
            <header class="header-card">
              <p>
                {{ $t('editionContact.identifiantDeConnexion')}}
              </p>
            </header>
            <div class="card-content">
              <div class="columns">
                <b-field class="column is-4">
                  <qd-switch v-model="contact.accesPortail" disabled>
                  </qd-switch>
                  <div>
                    {{ $t('editionContact.accesPortail') }}</div>
                </b-field>
                <div class="column is-8">
                  <span class="has-text-default is-italic">
                    {{$t('detailContact.identifiant')}} </span>
                  <span class="has-text-default has-text-weight-semibold">
                    {{contact.utilisateur.identifiant}} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeTab === constantes.TAB_CONTACTIERS">
      <contacts-tiers :contact="contact"
        :isEdit="false"
      >
      </contacts-tiers>
    </div>
    <b-modal v-model="isComponentSupprimerContact"
             has-modal-card
             class="modal">
      <app-supprimer-contact
        v-if="contact"
        oncancel="closePopUpSupprimer"
        :messHeader="this.$t('supprimerContact.delete')"
        :messFooter="this.$t('supprimerContact.irreversible')"
        :cancel="this.$t('supprimerContact.no')"
        :validate="this.$t('supprimerContact.yes')"
        :messagesPopup="messagesPopup"
        :isErrorPopup.sync="isErrorPopup"
        @yes="supprimerContact"
        @no="closePopUpSupprimer"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import dropdownButton from '@/components/general/button/dropdownButton';
import Avatar from 'vue-avatar';
import ContactsTiers from '@/components/tiers/contacts/m_ContactsTiers';
import { get as getContact, remove } from '@/api/contacts/index';
import { get as getTiers } from '@/api/tiers/index';
import messageErreur from '@/services/general/messageErreur';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { TIERS } from '@/configuration/permissionsBodacConf';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import messageSucces from '@/services/general/messageSucces';
import popUp from '@/components/general/popUpPrevention';
import validation from '@/services/contact/validation';
import MixinParametreInterne from '@/mixins/parametreInterne';

const Clients = createNamespacedHelpers('clients');
const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'detail-contact',
  props: [],
  mixins: [MixinParametreInterne],
  components: {
    Avatar,
    dropdownButton,
    AppBreadcrumb,
    appSupprimerContact: popUp,
    ContactsTiers,
  },
  data() {
    return {
      contact: false,
      nomClient: '',
      client: {},
      permClientsContacts: TIERS,
      isComponentSupprimerContact: false,
      messagesPopup: [''],
      isErrorPopup: false,
      activeTab: 'informations',
      constantes: {
        TAB_CONTACTIERS: 'contactsTiers',
        TAB_INFORMATIONS: 'informations',
      },
    };
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Clients.mapGetters({
      contacts: 'contacts',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    getNomPrenom() {
      return nomPrenomGetter(this.contact);
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeContacts.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeContacts.title'), route: { name: 'l.bodac.clients/contacts-contacts' }, isActive: false },
        { title: this.$i18n.t('detailContact.title', { nomPrenom: this.getNomPrenom }), route: { name: 'c.bodac.clients/contacts-contacts' }, isActive: true },
      ];
      return output;
    },
    civilites() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.civilite);
    },
    civilite() {
      if (!this.contact.civiliteId) return '';
      const civlib = this.civilites.find((element) => {
        return this.contact.civiliteId === element.id;
      });
      return civlib?.libelle || '';
    },
    modulePortailClientActive() {
      return this.parametresInterne(
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key);
    },
    afficherInfoPortail() {
      return this.contact.accesPortail && this.contact.utilisateurId
        && (this.modulePortailBailleurActive || this.modulePortailClientActive);
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t('general.button.delete'),
          action: () => { this.launchPopup(); },
          permissionAction: TIERS.supprimer,
        },
      ];

      return actions;
    },
    listeTypesContact() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.typeContact);
    },
    typesContact() {
      return cloneDeep(this.contact).typesContactIds.map((id) => {
        const typeLibelle = this.listeTypesContact.find((element) => {
          return id === element.id;
        })?.libelle;
        return typeLibelle;
      }).join(', ');
    },
    tabs() {
      return this.modulePortailClientActive ? [
        this.constantes.TAB_INFORMATIONS,
        this.constantes.TAB_CONTACTIERS,
      ] : [this.constantes.TAB_INFORMATIONS];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    closePopUpSupprimer() {
      this.isComponentSupprimerContact = false;
      this.messagesPopup = [];
      this.isErrorPopup = false;
    },
    async supprimerContact() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopup = false;
        await remove(this.contact.id);
        this.isComponentSupprimerContact = false;
        messageSucces(this.$i18n.t('supprimerContact.messages.suppression'));
        this.$router.push({ name: 'l.bodac.clients/contacts-contacts' });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          this.messagesPopup = [];
          validation(e.response, this.messagesPopup);
          this.isErrorPopup = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    launchPopup() {
      this.isComponentSupprimerContact = true;
      this.messagesPopup = [];
      this.isErrorPopup = false;
    },
  },
  async mounted() {
    if (!this.$route.params.id) {
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    this.id = this.$route.params.id;
    try {
      const contactResponse = await getContact(this.id);
      this.contact = { ...contactResponse.data.result };
      const clientResponse = await getTiers(this.contact.tiersId);
      this.nomClient = clientResponse.data.result.nomCommercial;
      if (!this.contact.adresseContactDifferente) {
        this.client = clientResponse.data.result;
      }
      await this.loadParametres([
        typesParametres.PARAMETRES_KEYS.civilite,
        typesParametres.PARAMETRES_KEYS.typeContact,
      ]);
      await this.loadParametresInterne([
        typesParametres.PARAMETRES_INTERNE_KEYS.modulePortailClient.key,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: nomPrenomGetter(this.contact) }));
  },
};
</script>

<style scoped>
</style>
